export default __webpack_public_path__ + "static/media/login-error.624f92f4.svg";